/**
 * How prose reads inside the task drawer (spec 096 FR-015, FR-016).
 *
 * One string, passed to the shared `Markdown` renderer by every drawer surface —
 * transcript messages, run summaries, comment bodies, the description — so the
 * four cannot drift apart. Body size with relaxed leading, long tokens broken,
 * and fenced code wrapped rather than scrolling, because a drawer has no width
 * to spare for a second horizontal scroller. The renderer's own defaults keep
 * code scrolling, which is what the file preview wants; these rules are the
 * drawer's.
 *
 * **The measure lives in `.drawer-prose`, on the text rather than on the block.**
 * It was a `max-w-prose` here, on the container, which capped everything inside
 * it: fenced code, tables and images too, none of them prose and none of them
 * with a reason to stop at 65 characters. Widening the drawer left them at a
 * paragraph's width with the rest of the room empty. The stylesheet now puts the
 * measure on the block children that are prose and exempts the ones that are
 * not, and raises the measure in wide mode instead of dropping it — spec 096's
 * fifth acceptance scenario, that a wide-mode paragraph stays capped at
 * something readable, still holds.
 */
export const DRAWER_PROSE_CLASS = [
  'drawer-prose text-sm leading-relaxed break-words',
  '[&_p]:first:mt-0 [&_p]:last:mb-0 [&_h2]:first:mt-0 [&_h3]:first:mt-0',
  '[&_pre]:whitespace-pre-wrap [&_pre]:[overflow-wrap:anywhere]',
].join(' ');
